<template>
    <transition name="el-fade-in-linear">
        <div class="popup-toast" v-if="visible">{{ text }}</div>
    </transition>

</template>

<script>
export default {
    name: "PopupToast",
    data(){
        return {
            visible: false,
            text: "",
            duration: 3000
        }
    },

    mounted(){
        this.setTimer();
    },
    methods: {
        /**
         * 停留 3秒后自动关闭
         */
        setTimer: function(){
            setTimeout(()=>{
                this.handleClose();
            }, this.duration)
        },
        /**
         * 关闭后销毁组件
         */
        handleClose: function(){
            this.visible = false;
            setTimeout(()=>{
                this.$el.parentNode.removeChild(this.$el);
            }, 500)
        },

    },
}
</script>

<style scoped>
div.popup-toast{
    width: 1.5rem;
    position: fixed;
    margin-left: calc((100vw - 1.5rem) / 2);
    bottom: 1rem;
    z-index: 1000;
    padding: 0.1rem 0.1rem;
    background: rgba(0,0,0, 0.5);
    font-family: PF-Regular, sans-serif;
    color: #FFFFFF;
    font-size: 0.14rem;
    text-align: center;
    line-height: 0.2rem;
    border-radius: 0.05rem;
}
</style>